import { ScrollView } from 'react-native';
import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import type { RankingFilterMarketVerticalType } from 'shared/src/api';

const ICON_SIZE = 56;

interface MarketTypeFilterProps {
  marketTypes: RankingFilterMarketVerticalType[];
  selectedSno: number | null;
  onSelect: (marketType: RankingFilterMarketVerticalType) => void;
}

export const MarketTypeFilter = ({
  marketTypes,
  selectedSno,
  onSelect,
}: MarketTypeFilterProps) => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ paddingHorizontal: 16, paddingVertical: 12 }}
    >
      <Flex.Row gap={8}>
        {marketTypes.map(marketType => {
          const isSelected = marketType.sno === selectedSno;
          return (
            <Flex
              key={marketType.sno}
              width={64}
              alignItems="center"
              gap={8}
              onPress={() => onSelect(marketType)}
            >
              <Flex
                width={ICON_SIZE}
                height={ICON_SIZE}
                borderRadius={ICON_SIZE / 2}
                overflow="hidden"
                borderWidth={isSelected ? 1.5 : 0}
                borderColor={isSelected ? 'content_primary' : undefined}
              >
                <RemoteImage
                  uri={marketType.image}
                  width={ICON_SIZE}
                  height={ICON_SIZE}
                />
              </Flex>
              <Typography
                type={isSelected ? 'subtitle5' : 'body5'}
                color="content_primary"
              >
                {marketType.name}
              </Typography>
            </Flex>
          );
        })}
      </Flex.Row>
    </ScrollView>
  );
};
